import { FormPartialDataUsPersonInfo } from "../../components/FormPartialUsPersonInfo";
import { CertifyTaxPayerInfo } from "../../steps/CertifyTaxPayerInfo";
import { StepUsPersonInfoForm } from "./steps/StepUsPersonInfoForm";
import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export type FormDataUsPersonInfo = {
  isUsPerson: boolean;
  usPersonInfo: FormPartialDataUsPersonInfo;
};

export type FlowUsPersonInfoContext = {
  usPersonInfo?: FormDataUsPersonInfo;
};

export function getUsPersonInfoSteps(
  context: FlowUsPersonInfoContext
): FlowStep[] {
  return [
    {
      title: "Update taxpayer info",
      slug: "update",
      component: StepUsPersonInfoForm
    },
    {
      title: "Certify taxpayer info",
      slug: "certify",
      component: CertifyTaxPayerInfo
    }
  ];
}
